import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SundryFactorySummaryReport } from './Pages';

export const SundryFactorySummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={SundryFactorySummaryReport} />
       
    </Fragment>
)